import React from 'react';
import { Row as AntRow } from 'antd';
import type { RowProps } from 'antd';
import clsx from 'clsx';

/**
 * Thin wrapper over the Antd Row (per the antd wrapper standardization plan):
 * single import source through @common/components and a `wk-row` class hook.
 */
export const Row = ({ className, ...props }: RowProps) => (
  <AntRow {...props} className={clsx('wk-row', className)} />
);
